/**
 * Frontend logger. A thin wrapper over `console.*` with a domain-prefix
 * convention that matches `.claude/rules/logging.md` and the server-side
 * logger. Future versions will route ERROR-level events to PostHog or Sentry
 * when those are added.
 *
 * Usage:
 *   logger.info('[apollo] hydrated cache', { entries });
 *   logger.error('[auth] redirect callback missing state', { url });
 */
type Meta = Record<string, unknown>;

export const logger = {
  info(message: string, meta?: Meta): void {
    // eslint-disable-next-line no-console
    console.info(message, meta ?? {});
  },
  warn(message: string, meta?: Meta): void {
    console.warn(message, meta ?? {});
  },
  error(message: string, meta?: Meta): void {
    console.error(message, meta ?? {});
  },
  debug(message: string, meta?: Meta): void {
    if (import.meta.env.DEV) {
      // eslint-disable-next-line no-console
      console.debug(message, meta ?? {});
    }
  },
};
